import Menu, { buildTogglerId } from "Components/menu";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import React, { useCallback, useEffect, useMemo } from "react";
import { ITEM_SIZES, SidebarMenuList } from "../../Common";
import buildRunMethodsError from "../utils/buildRunMethodsError";
import buildScriptActionsMenuItems from "../utils/buildScriptActionsMenuItems";
import buildScriptSidebarItems from "../utils/buildScriptSidebarItems";
import locale from "./tabScripts.locale";
export default function TabScripts(props) {
    useEffect(() => {
        props.onInitialized && props.onInitialized();
    }, [props.onInitialized]);
    useEffect(() => {
        !props.isExpanded &&
            props.onSetShowScriptEditorPanel &&
            props.onSetShowScriptEditorPanel(false);
    }, [props.isExpanded]);
    const handleRunScripts = useCallback((script, nodesSource) => {
        if (!props.documentObjects ||
            !props.activeDocumentId ||
            !nodesSource.length ||
            !script.Methods)
            return;
        const invalidMessage = buildRunMethodsError(props.documentObjects, map(script.Methods, method => ({ method, nodesSource })));
        if (!invalidMessage) {
            props.onRunScript && props.onRunScript(props.activeDocumentId, script.Id, nodesSource);
        }
        else {
            props.showError && props.showError(invalidMessage);
        }
    }, [props.activeDocumentId, props.documentObjects, props.onRunScript, props.showError]);
    const sidebarMenuItems = useMemo(() => {
        if (!props.data || !props.selectedNodesSource)
            return undefined;
        if (!props.selectedNodesSource.length)
            return [];
        return buildScriptSidebarItems(props.data, props.selectedNodesSource, props.readOnlyMode, props.canRunScripts ? handleRunScripts : undefined, props.canRunScripts
            ? (script) => {
                const id = `sidebarScriptMenu${script.Id}`;
                return (React.createElement(Menu, { key: "menu", popoverClassName: "dark-popover1", id: id, togglerClassName: "no-border no-default-colors animate-hover-color", togglerIconClassName: "icon-cog-filled", togglerWidth: ITEM_SIZES.MIN_ACTION_ELEMENT_SIZE, togglerHeight: ITEM_SIZES.MIN_ACTION_ELEMENT_SIZE, items: buildScriptActionsMenuItems(script, (item) => {
                        props.onSetShowScriptEditorPanel &&
                            props.onSetShowScriptEditorPanel(true, item, `#${buildTogglerId(id)}`);
                    }, props.onDeleteScript) }));
            }
            : undefined);
    }, [
        props.canRunScripts,
        props.readOnlyMode,
        props.data,
        props.selectedNodesSource,
        handleRunScripts,
        props.onSetShowScriptEditorPanel,
        props.onDeleteScript
    ]);
    const emptyText = isEmpty(props.selectedNodesSource)
        ? locale.SELECT_OBJECT
        : isEmpty(props.data)
            ? locale.NO_AVAILABLE_SCRIPTS
            : "";
    return (React.createElement(SidebarMenuList, { className: props.className, bgColorDefault: props.bgColorDefault, bgColorActive: props.bgColorActive, inProgress: props.inProgress, sidebarMenuItems: sidebarMenuItems, emptyText: emptyText, filterText: props.filterText, sortBy: props.sortBy, sortOrder: props.sortOrder }));
}
